/**
 * @license Copyright 2019 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
 */

.lhr-comparison-legend {
  display: flex;
  flex-direction: row;
  align-items: center;

  margin-right: var(--base-spacing);
  width: fit-content;
  padding: var(--base-spacing) calc(var(--base-spacing) * 1.5);

  background: var(--highlighted-background-color);
  border: 1px solid var(--base-border-color);
  border-radius: 9999px; /* force fully rounded corners */
}

.lhr-comparison-legend__label {
  font-family: var(--monospace-font-family);
  font-size: var(--monospace-font-size);
  margin-left: calc(var(--base-spacing) / 2);
  margin-right: calc(var(--base-spacing) * 1.5);
}

.lhr-comparison-legend__label:last-child {
  margin-right: 0;
}

.lhr-comparison-legend__chip {
  display: 'block';
  width: var(--base-icon-size);
  height: var(--base-icon-size);
  border-radius: 2px;
}

.lhr-comparison-legend__chip--regression {
  background: var(--regression-color);
}

.lhr-comparison-legend__chip--improvement {
  background: var(--improvement-color);
}
